/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import * as keys from '../../../services/config/Keys';
import PaymentChannels from '../channels/PaymentChannels';

const SubPlanCard = ({ monthlySub, checked, onChange, planName }) => {
  const [monthNum, setMonthNum] = useState('1');

  return (
    <div className="col-xl-5 col-md-6 mb-4">
      <div className="card box shadow h-100 py-2">
        <div className="card-body">
          <div className="row col-auto align-items-center">
            <div className="col-auto">
              <div className=" text-center d-flex mb-0">
                <div>
                  <img
                    src="images/residential.png"
                    alt="House"
                    className="mr-2 mt-3"
                  />
                </div>
                <div className="text-left">
                  <div className="font_18 text-wrap bolder_font margin_bottom">
                    {planName}
                  </div>
                  <div className="form-group d-flex mb-0 pb-0">
                    <select
                      defaultValue={monthNum}
                      id="monthNum"
                      className="form-control form-control-sm mt-2 mr-3"
                      onChange={(e) => setMonthNum(e.target.value)}
                    >
                      <option value="1">1 Month</option>
                      <option value="2">2 Months</option>
                      <option value="3">3 Months</option>
                      <option value="6">6 Months (+ 1 month free)</option>
                      <option value="12">1 Year (+ 2 months free)</option>
                    </select>
                    <label
                      className="d-flex mt-3 lighter_font"
                      htmlFor="monthNum"
                    >
                      GH₵
                      <span className="ml-1">{monthNum * monthlySub}</span>
                    </label>
                  </div>
                  <div className="custom-control custom-checkbox">
                    <label className="checkbox-inline mt-0 lighter_font text-nowrap">
                      <input
                        type="checkbox"
                        className="custom-control-input"
                        checked={checked}
                        onChange={onChange}
                      />
                      <span
                        className={
                          monthNum !== '2'
                            ? 'ml-1 custom-control-label'
                            : 'd-none'
                        }
                      >
                        I want to be charged{' '}
                        {monthNum === '1'
                          ? 'monthly'
                          : monthNum === '3'
                          ? 'quarterly'
                          : monthNum === '6'
                          ? 'bi-annually'
                          : monthNum === '12'
                          ? 'yearly'
                          : null}
                      </span>
                    </label>
                  </div>
                </div>
              </div>

              {monthlySub === '300' ? (
                <PaymentChannels
                  paystackPlanCode={
                    monthNum === '1'
                      ? `${keys.PAYSTACK_150_PLAN_1_MONTH}`
                      : monthNum === '3'
                      ? `${keys.PAYSTACK_150_PLAN_3_MONTHS}`
                      : monthNum === '6'
                      ? `${keys.PAYSTACK_150_PLAN_6_MONTHS}`
                      : monthNum === '12'
                      ? `${keys.PAYSTACK_150_PLAN_1_YEAR}`
                      : null
                  }
                  ravePlanCode={
                    monthNum === '1'
                      ? `${keys.FLUTTERWAVE_150_PLAN_1_MONTH}`
                      : monthNum === '3'
                      ? `${keys.FLUTTERWAVE_150_PLAN_3_MONTHS}`
                      : monthNum === '6'
                      ? `${keys.FLUTTERWAVE_150_PLAN_6_MONTHS}`
                      : monthNum === '12'
                      ? `${keys.FLUTTERWAVE_150_PLAN_1_YEAR}`
                      : null
                  }
                  checked={checked}
                  monthNum={monthNum}
                  amount={monthNum * monthlySub}
                />
              ) : monthlySub === '350' ? (
                <PaymentChannels
                  paystackPlanCode={
                    monthNum === '1'
                      ? `${keys.PAYSTACK_200_PLAN_1_MONTH}`
                      : monthNum === '3'
                      ? `${keys.PAYSTACK_200_PLAN_3_MONTHS}`
                      : monthNum === '6'
                      ? `${keys.PAYSTACK_200_PLAN_6_MONTHS}`
                      : `${keys.PAYSTACK_200_PLAN_1_YEAR}`
                  }
                  ravePlanCode={
                    monthNum === '1'
                      ? `${keys.FLUTTERWAVE_200_PLAN_1_MONTH}`
                      : monthNum === '3'
                      ? `${keys.FLUTTERWAVE_200_PLAN_3_MONTHS}`
                      : monthNum === '6'
                      ? `${keys.FLUTTERWAVE_200_PLAN_6_MONTHS}`
                      : monthNum === '12'
                      ? `${keys.FLUTTERWAVE_200_PLAN_1_YEAR}`
                      : null
                  }
                  checked={checked}
                  amount={monthNum * monthlySub}
                />
              ) : monthlySub === '400' ? (
                <PaymentChannels
                  paystackPlanCode={
                    monthNum === '1'
                      ? `${keys.PAYSTACK_250_PLAN_1_MONTH}`
                      : monthNum === '3'
                      ? `${keys.PAYSTACK_250_PLAN_3_MONTHS}`
                      : monthNum === '6'
                      ? `${keys.PAYSTACK_250_PLAN_6_MONTHS}`
                      : `${keys.PAYSTACK_250_PLAN_1_YEAR}`
                  }
                  ravePlanCode={
                    monthNum === '1'
                      ? `${keys.FLUTTERWAVE_250_PLAN_1_MONTH}`
                      : monthNum === '3'
                      ? `${keys.FLUTTERWAVE_250_PLAN_3_MONTHS}`
                      : monthNum === '6'
                      ? `${keys.FLUTTERWAVE_250_PLAN_6_MONTHS}`
                      : monthNum === '12'
                      ? `${keys.FLUTTERWAVE_250_PLAN_1_YEAR}`
                      : null
                  }
                  checked={checked}
                  amount={monthNum * monthlySub}
                />
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

SubPlanCard.propTypes = {
  checked: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]).isRequired,
  onChange: PropTypes.func.isRequired,
  monthlySub: PropTypes.string.isRequired,
  planName: PropTypes.string.isRequired,
};

export default SubPlanCard;
